export async function downloadReport(client, endpoint, params, filename) {
  const response = await client.get(endpoint, { params, responseType: 'blob' });
  if (!response.data || !response.data.size) throw new Error('The export returned an empty file.');
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Give the browser time to begin reading the download before releasing it.
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
}

export async function reportErrorMessage(error) {
  if (error.response && error.response.data instanceof Blob) {
    try {
      const body = JSON.parse(await error.response.data.text());
      if (body.message) return body.message;
    } catch (parseError) { /* Proxies may return HTML instead of JSON. */ }
  }
  return error.code === 'ECONNABORTED'
    ? 'Export timed out. Please retry with a smaller date range when available.'
    : 'Unable to download the report. Please check your connection and retry.';
}
